import Vue from 'vue'
import { uuid } from 'vue-uuid'
import localforageKeys from '../../helper/localForageKeys'

export const CLEAR_SETTINGS_WEBCHAT_STORE = 'CLEAR_SETTINGS_WEBCHAT_STORE'
export const SET_SETTINGS_WEBCHAT = 'SET_SETTINGS_WEBCHAT'
export const SET_GENERIC_EVENTS = 'SET_GENERIC_EVENTS'
export const SET_AVAILABLE_UPDATE = 'SET_AVAILABLE_UPDATE'

const state = {
  isUpdateAvailable: false,
  settingsWebchat: {},
  genericEventsIsWritingLoading: true
}

const getters = {
  getterIsUpdateAvailable: (state) => state.isUpdateAvailable,
  getterSettingWebchat: (state) => state.settingsWebchat,
  getterGenericEventsIsWritingLoading: (state) => state.genericEventsIsWritingLoading
}

const mutations = {
  [SET_AVAILABLE_UPDATE] (state, params) {
    state.isUpdateAvailable = params
  },
  [SET_SETTINGS_WEBCHAT] (state, params) {
    state.settingsWebchat = params
  },
  [SET_GENERIC_EVENTS] (state, params) {
    state[`genericEvents${params.key}`] = params.value
  },
  [CLEAR_SETTINGS_WEBCHAT_STORE] (state) {
    state.settingsWebchat = {}
    state.genericEventsIsWritingLoading = false
  }
}

const actions = {
  actionGlobalDisconnect ({ dispatch }, botId) {
    Vue.prototype.$globalRouter.push('/').then(() => {
      if (botId) {
        // eslint-disable-next-line no-restricted-globals
        history.pushState({}, '', botId)
      }
    })

    dispatch('cleanStorage')
  },
  actionGetLocalForageUserId () {
    return localStorage.getItem(localforageKeys.USER_ID('localforage/'))
  },
  actionSetLocalForageUserId (_, userId) {
    return localStorage.setItem(localforageKeys.USER_ID('localforage/'), userId)
  },
  actionGetLocalForageListTabs () {
    return Vue.prototype.$getItem(localforageKeys.ACTIVE_TABS())
      .then((response) => {
        if (response) {
          return response
        }

        return []
      })
  },
  actionSetLocalForageListTabs (_, list) {
    let listToSet = []

    list.forEach(element => {
      if (typeof element === 'number') {
        listToSet = listToSet.concat(element)
      }
    })

    return Vue.prototype.$setItem(localforageKeys.ACTIVE_TABS(), listToSet)
  },
  actionSetSessionStorageUserId () {
    sessionStorage.setItem('userId', uuid.v4())
  },
  actionGetSessionStorageUserId () {
    return sessionStorage.getItem('userId')
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
